import React from 'react';
import { useNavigate } from 'react-router';
import { ReactComponent as EyeIcon } from '../../assets/icons/eye.svg';
import { formatUKDate, capitalize } from '../../utils';
import './BloodUploadTrackerTable.scss';

import { BloodUploadTrackerResult } from '../../api/oldBloodTest';

interface TrackerRowProps {
    rowData: BloodUploadTrackerResult;
}

const TrackerRow: React.FC<TrackerRowProps> = ({ rowData }) => {
    const navigate = useNavigate();

    const handleLinkClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        navigate(`/members/${rowData.member_id}`, { state: { activeTab: 'oldBloodTests' } });
    };

    const fullName = `${rowData.member_first_name} ${rowData.member_last_name}`.trim();

    const statusDisplay = rowData.status === 'PENDING' ? 'UPLOADED' : rowData.status;

    return (
        <div className='table-row'>
            <div className='memberName'>{fullName}</div>
            <div className='planType'>{capitalize(rowData.plan_type)}</div>
            <div className='fileName'>{rowData.file_name}</div>
            <div className='dateUploaded'>{formatUKDate(rowData.upload_date, 'dd-MM-yyyy')}</div>
            <div className={`status ${statusDisplay.toLowerCase().replace(' ', '-')}`}>
                {statusDisplay}
            </div>
            <div className='actions'>
                <EyeIcon className='view-icon' onClick={handleLinkClick} />
            </div>
        </div>
    );
};

export default TrackerRow;
